import { render, staticRenderFns } from "./CampaignCouponList.vue?vue&type=template&id=c2db27c6&scoped=true"
import script from "./CampaignCouponList.vue?vue&type=script&lang=js"
export * from "./CampaignCouponList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2db27c6",
  null
  
)

export default component.exports